import React, { useState, useEffect } from 'react';
import ChallengeCard from '../components/ChallengeCard';
import challengesData from '../challenges/challenges.json';
import Header from '../components/Header';  // Import Header

function Challenges({ user }) {
  const [challenges, setChallenges] = useState([]);
  const [selectedDifficulty, setSelectedDifficulty] = useState('all');
  const [selectedType, setSelectedType] = useState('all');

  useEffect(() => {
    setChallenges(challengesData.challenges);
  }, []);

  // Filter challenges based on both selected difficulty and type
  const filteredChallenges = challenges.filter((challenge) => {
    const matchesDifficulty = selectedDifficulty === 'all' || challenge.difficulty === selectedDifficulty;
    const matchesType = selectedType === 'all' || challenge.type === selectedType;
    return matchesDifficulty && matchesType;
  });

  return (
    <div>
      {/* Display the Header */}
      <Header user={user} />
      
      {/* Challenge content */}
      <div className="p-8 bg-darkBackground min-h-screen flex flex-col">
        <h2 className="text-3xl font-bold text-textWhite mb-8">Choose a Challenge</h2>

        {/* Filters Row */}
        <div className="flex space-x-4 mb-4">
          <div>
            <label className="text-textWhite mr-2">Filter by difficulty:</label>
            <select 
              value={selectedDifficulty} 
              onChange={(e) => setSelectedDifficulty(e.target.value)} 
              className="bg-gray-700 text-white p-2 rounded-md"
            >
              <option value="all">All</option>
              <option value="beginner">Beginner</option>
              <option value="easy">Easy</option>
              <option value="medium">Medium</option>
              <option value="hard">Hard</option>
              <option value="extreme">Extreme</option>
              <option value="impossible">Impossible</option>
            </select>
          </div>

          <div>
            <label className="text-textWhite mr-2">Filter by type:</label>
            <select 
              value={selectedType} 
              onChange={(e) => setSelectedType(e.target.value)} 
              className="bg-gray-700 text-white p-2 rounded-md"
            >
              <option value="all">All</option>
              <option value="web">Web Exploitation</option>
              <option value="steganography">Steganography</option>
              <option value="terminal">Command Line</option>
              <option value="cryptography">Cryptography</option>
              <option value="binary_exploitation">Binary Exploitation</option>
              <option value="reverse_engineering">Reverse Engineering</option>
              <option value="networking">Networking</option>
              <option value="osint">OSINT</option>
              <option value="forensics">Forensics</option>
              <option value="social_engineering">Social Engineering</option>
            </select>
          </div>
        </div>

        {/* Masonry Layout with CSS Columns */}
        <div className="columns-1 sm:columns-2 md:columns-3 lg:columns-4 gap-4">
          {filteredChallenges.length > 0 ? (
            filteredChallenges.map((challenge) => (
              <div key={challenge.id} className="mb-4 break-inside-avoid">
                <ChallengeCard challenge={challenge} />
              </div>
            ))
          ) : (
            <p className="text-textWhite">No challenges found.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Challenges;
